export default __webpack_public_path__ + "static/media/3.69c99e08.webp";